import { CheckIcon } from "@heroicons/react/20/solid";
import { useCallback } from "react";
import type { Key } from "react-aria-components";
import { cn } from "cn";
import { ListBox, ListBoxItem, ListBoxLabel } from "@/components/ui/list-box.tsx";

export interface FilterKindListProps<TKind extends string> {
    ariaLabel: string;
    kinds: readonly TKind[];
    appliedKinds: ReadonlySet<TKind>;
    getKindLabel: (kind: TKind) => string;
    appliedLabel: string;
    onSelect: (kind: TKind) => void;
    className?: string;
}

export function FilterKindList<TKind extends string>({ ariaLabel, kinds, appliedKinds, getKindLabel, appliedLabel, onSelect, className }: FilterKindListProps<TKind>) {
    const handleAction = useCallback(
        (key: Key) => {
            const kind = kinds.find(candidate => candidate === key);

            if (kind) {
                onSelect(kind);
            }
        },
        [kinds, onSelect]
    );

    return (
        <ListBox aria-label={ariaLabel} className={cn("max-h-none border-0", className)} onAction={handleAction}>
            {kinds.map(kind => (
                <ListBoxItem key={kind} id={kind} textValue={getKindLabel(kind)}>
                    <ListBoxLabel>{getKindLabel(kind)}</ListBoxLabel>
                    {appliedKinds.has(kind) && (
                        <>
                            <CheckIcon aria-hidden="true" />
                            <span className="sr-only">{appliedLabel}</span>
                        </>
                    )}
                </ListBoxItem>
            ))}
        </ListBox>
    );
}
